import { GEOTRAX_PAGE_SELECTED } from '../../constants/appConstants';
import { NavItem } from '../../constants/navConstants';

export const geotraxPageSelected = (page: NavItem) => ({
  type: GEOTRAX_PAGE_SELECTED,
  payload: page,
});

export default geotraxPageSelected;
